var _path, _path2, _path3, _g, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeOffice = function SvgHomeOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.538 121.422C513.128 73.682 436.114 48.874 359.926 43.302C245.126 34.902 177.926 95.102 176.526 156.702C175.126 218.302 143.024 285.236 67.3262 361.676C-8.37183 438.116 9.92616 552.902 137.326 589.302C264.726 625.702 369.726 572.502 413.126 541.702C456.526 510.902 547.526 600.502 607.726 571.102C646.044 552.384 662.116 488.432 670.544 451.374C686.266 382.172 685.104 307.174 660.744 240.086C642.922 191.31 612.094 151.872 573.538 121.422Z",
    fill: "#1B5FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M573.538 121.422C513.128 73.682 436.114 48.874 359.926 43.302C245.126 34.902 177.926 95.102 176.526 156.702C175.126 218.302 143.024 285.236 67.3262 361.676C-8.37183 438.116 9.92616 552.902 137.326 589.302C264.726 625.702 369.726 572.502 413.126 541.702C456.526 510.902 547.526 600.502 607.726 571.102C646.044 552.384 662.116 488.432 670.544 451.374C686.266 382.172 685.104 307.174 660.744 240.086C642.922 191.31 612.094 151.872 573.538 121.422Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M369.236 33.6V411.278",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.42 558.796H113.722C109.972 558.796 106.932 561.836 106.932 565.586V614.754C106.932 618.504 109.972 621.544 113.722 621.544H455.42C459.17 621.544 462.21 618.504 462.21 614.754V565.586C462.21 561.836 459.17 558.796 455.42 558.796Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.032 522.34H432.11C435.147 522.34 438.06 523.547 440.208 525.694C442.356 527.842 443.562 530.755 443.562 533.792V621.6H125.58V533.792C125.58 530.755 126.787 527.842 128.934 525.694C131.082 523.547 133.995 522.34 137.032 522.34Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.548 580.846H125.58V621.544H443.548V580.846Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3301 621.796H686.546",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.122 522.34H513.926V621.544H668.122V522.34Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.726 530.964H520.17V564.312H586.726V530.964Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.408 530.964H593.852V564.312H660.408V530.964Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.726 572.152H520.17V605.5H586.726V572.152Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.408 572.152H593.852V605.5H660.408V572.152Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.122 514.29H513.926V522.34H668.122V514.29Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.61 460.908C589.003 459.306 587.82 457.988 586.292 457.211C584.765 456.435 583.003 456.255 581.35 456.708L576.366 451.108C576.552 450.467 576.545 449.785 576.346 449.147C576.147 448.51 575.764 447.946 575.246 447.524C574.917 447.157 574.516 446.862 574.068 446.655C573.62 446.448 573.135 446.334 572.642 446.32C571.64 446.331 570.682 446.737 569.977 447.45C569.272 448.163 568.876 449.125 568.876 450.128C568.873 450.606 568.959 451.081 569.128 451.528L538.608 479.64C538.145 479.406 537.636 479.274 537.117 479.252C536.598 479.231 536.08 479.32 535.598 479.514C534.809 479.815 534.142 480.372 533.704 481.095C533.267 481.818 533.083 482.667 533.183 483.506C533.283 484.346 533.66 485.128 534.255 485.729C534.85 486.329 535.628 486.714 536.466 486.822L540.96 504.42H531.86C531.098 504.42 530.343 504.57 529.639 504.862C528.935 505.155 528.295 505.583 527.757 506.123C527.219 506.662 526.792 507.303 526.502 508.008C526.211 508.712 526.063 509.468 526.064 510.23V514.682H561.4V510.23C561.4 508.689 560.788 507.211 559.699 506.122C558.609 505.032 557.131 504.42 555.59 504.42H543.886L539.224 486.136C539.716 485.787 540.117 485.325 540.392 484.789C540.667 484.253 540.81 483.659 540.806 483.056C540.808 482.578 540.722 482.104 540.554 481.656L571.018 453.6C571.542 453.854 572.116 453.988 572.698 453.992C573.384 453.987 574.056 453.799 574.644 453.446L578.844 458.038C577.727 458.952 576.926 460.194 576.554 461.588C576.182 462.983 576.258 464.459 576.772 465.808L579.768 473.592L592.662 468.636L589.61 460.908Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8861 536.76C95.8861 536.76 96.6701 533.428 96.6981 533.204C96.9501 530.698 95.9841 525.672 93.3801 524.524C92.9433 524.349 92.4748 524.267 92.0046 524.284C91.5343 524.3 91.0727 524.415 90.6495 524.621C90.2263 524.827 89.8508 525.119 89.5471 525.478C89.2434 525.837 89.0182 526.256 88.8861 526.708C88.6869 527.709 88.709 528.741 88.9508 529.733C89.1927 530.725 89.6484 531.651 90.2861 532.448C91.5741 534.254 95.8861 536.76 95.8861 536.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5419 537.446C47.6139 538.258 52.5419 537.978 52.5419 537.978C52.5419 537.978 51.3519 534.758 51.2539 534.562C50.0779 532.322 46.4939 528.668 43.7079 529.144C43.2554 529.244 42.8284 529.436 42.4535 529.708C42.0785 529.981 41.7637 530.327 41.5286 530.727C41.2935 531.126 41.1431 531.569 41.0869 532.029C41.0307 532.489 41.0699 532.956 41.2019 533.4C41.5849 534.351 42.1721 535.206 42.922 535.906C43.672 536.605 44.5663 537.131 45.5419 537.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7677 551.796C49.8817 552.02 54.2777 550.578 54.6277 550.466C55.4558 552.976 56.4425 555.431 57.5817 557.816C58.2397 559.216 58.9817 560.616 59.6817 562.016C59.2617 561.442 58.8697 560.924 58.8137 560.868C57.0917 559.006 52.6677 556.43 50.0917 557.634C49.6713 557.846 49.3001 558.143 49.0022 558.508C48.7042 558.872 48.4861 559.295 48.362 559.749C48.238 560.203 48.2107 560.678 48.2819 561.144C48.3532 561.609 48.5214 562.054 48.7757 562.45C49.3997 563.258 50.193 563.92 51.1 564.389C52.0069 564.858 53.0055 565.124 54.0257 565.166C56.2994 565.087 58.5472 564.657 60.6897 563.892C60.9837 564.424 61.2497 564.956 61.5437 565.474C62.9437 567.994 64.3437 570.486 65.5897 572.992C66.0377 573.86 66.4437 574.742 66.8637 575.624C66.4857 575.12 66.1637 574.686 66.1077 574.63C64.3857 572.768 59.9617 570.206 57.3997 571.396C56.9793 571.608 56.6081 571.905 56.3102 572.27C56.0122 572.634 55.7941 573.057 55.67 573.511C55.546 573.965 55.5187 574.44 55.5899 574.906C55.6612 575.371 55.8294 575.816 56.0837 576.212C56.7062 577.018 57.4973 577.679 58.4017 578.148C59.306 578.618 60.3019 578.884 61.3197 578.928C63.5349 578.86 65.7262 578.449 67.8157 577.71C68.2077 578.634 68.6137 579.544 68.9637 580.51C69.1737 581.14 69.4397 581.714 69.6217 582.358C69.8037 583.002 70.0277 583.604 70.2237 584.22C70.5457 585.424 70.9097 586.656 71.2037 587.846C71.4137 588.658 71.5957 589.442 71.7917 590.226C71.3437 589.358 70.3917 587.65 70.3917 587.51C68.9917 585.41 64.9877 582.204 62.2717 583.002C61.8352 583.147 61.4329 583.379 61.0895 583.685C60.7461 583.991 60.4689 584.364 60.2749 584.781C60.0808 585.198 59.9741 585.65 59.9611 586.11C59.9482 586.569 60.0294 587.027 60.1997 587.454C60.6946 588.345 61.3782 589.118 62.2028 589.718C63.0274 590.318 63.9731 590.73 64.9737 590.926C67.3072 591.187 69.6667 591.098 71.9737 590.66C72.2817 591.962 72.5757 593.236 72.8277 594.44C73.7237 598.64 74.2977 602.126 74.6757 604.59L76.5937 604.52V604.296C76.1737 601.818 75.5017 598.276 74.5077 594.076C74.1997 592.746 73.8497 591.276 73.4577 589.876C74.7676 589.305 76.0396 588.65 77.2657 587.916C79.0234 589.327 80.9695 590.487 83.0477 591.36C82.5857 592.62 82.1237 593.838 81.6477 594.986C80.0797 598.962 78.6237 602.21 77.5877 604.464H79.6877C80.6537 602.224 81.8997 599.228 83.2157 595.658C83.6917 594.384 84.1677 592.998 84.6157 591.584C86.92 592.041 89.2811 592.14 91.6157 591.878C92.6176 591.685 93.5652 591.276 94.3923 590.679C95.2193 590.081 95.9058 589.31 96.4037 588.42C96.6038 587.982 96.7072 587.505 96.707 587.023C96.7067 586.541 96.6028 586.065 96.4023 585.627C96.2018 585.189 95.9093 584.799 95.5448 584.484C95.1803 584.168 94.7523 583.935 94.2897 583.8C91.5737 582.988 87.5837 586.194 86.1557 588.28C86.0717 588.406 85.3017 589.834 84.8397 590.758L85.4137 589.008C85.8057 587.832 86.1557 586.642 86.5337 585.354L87.0377 583.464C87.2057 582.834 87.3177 582.148 87.4717 581.476C87.7797 579.936 88.0177 578.354 88.2277 576.758C90.3571 577.518 92.5903 577.948 94.8497 578.032C95.8632 578 96.8576 577.748 97.7641 577.293C98.6705 576.839 99.4675 576.193 100.1 575.4C100.359 575.007 100.533 574.563 100.608 574.098C100.684 573.633 100.66 573.158 100.539 572.702C100.417 572.247 100.2 571.823 99.9023 571.458C99.6047 571.093 99.2329 570.795 98.8117 570.584C96.2357 569.366 91.8117 571.984 90.0897 573.776C89.9777 573.888 88.8857 575.344 88.2977 576.17C88.4097 575.204 88.5357 574.238 88.6197 573.272C88.8717 570.472 89.0397 567.588 89.2077 564.732C89.2077 563.85 89.3337 562.982 89.3897 562.114C89.7537 562.226 94.1217 563.682 96.2497 563.514C97.2677 563.475 98.2648 563.214 99.1716 562.75C100.078 562.286 100.873 561.629 101.5 560.826C101.757 560.431 101.927 559.987 102.001 559.522C102.074 559.057 102.049 558.581 101.926 558.127C101.803 557.672 101.586 557.249 101.288 556.884C100.99 556.519 100.618 556.221 100.198 556.01C97.6357 554.792 93.1977 557.41 91.4757 559.202C91.3497 559.342 89.7817 561.442 89.4037 562.002C89.5437 560.084 89.6837 558.166 89.9217 556.29C90.2307 553.748 90.6983 551.228 91.3217 548.744C91.5037 548.814 96.0537 550.34 98.2237 550.144C99.2417 550.105 100.239 549.844 101.146 549.38C102.052 548.916 102.847 548.259 103.474 547.456C103.756 547.059 103.949 546.605 104.038 546.126C104.127 545.647 104.11 545.154 103.989 544.682C103.868 544.21 103.645 543.77 103.336 543.393C103.027 543.016 102.639 542.711 102.2 542.5C99.6377 541.282 95.1997 543.9 93.4777 545.692C93.3657 545.804 92.1617 547.414 91.6157 548.198L91.4617 548.128C92.1767 545.645 93.1138 543.232 94.2617 540.918C94.8637 539.63 95.5077 538.44 96.1517 537.292C98.2217 538.296 100.43 538.985 102.704 539.336C103.721 539.409 104.741 539.259 105.694 538.896C106.647 538.533 107.509 537.967 108.22 537.236C108.519 536.873 108.737 536.45 108.862 535.997C108.987 535.543 109.014 535.068 108.943 534.603C108.872 534.138 108.703 533.693 108.448 533.298C108.193 532.902 107.858 532.565 107.464 532.308C105.056 530.824 100.366 532.868 98.4477 534.52C98.3357 534.604 97.3697 535.64 96.6837 536.396C96.9917 535.878 97.2857 535.346 97.5937 534.856C98.7137 533.036 99.8617 531.426 100.87 530.012C101.458 529.214 102.004 528.514 102.522 527.856C104.814 527.798 107.085 527.392 109.256 526.652C110.191 526.247 111.026 525.642 111.703 524.88C112.38 524.118 112.883 523.218 113.176 522.242C113.272 521.782 113.271 521.308 113.172 520.849C113.073 520.39 112.879 519.956 112.602 519.577C112.324 519.198 111.97 518.882 111.563 518.649C111.155 518.416 110.703 518.271 110.236 518.224C107.436 518.014 104.188 521.99 103.236 524.342C103.152 524.538 102.228 527.87 102.284 527.856C101.78 528.486 101.234 529.158 100.66 529.914C99.6097 531.314 98.4337 532.882 97.2577 534.688C95.9823 536.627 94.8184 538.637 93.7717 540.708C92.5939 543.021 91.6241 545.434 90.8737 547.918C90.8755 547.951 90.8755 547.983 90.8737 548.016C90.8737 547.19 90.7477 544.866 90.7057 544.684C90.2997 542.192 88.0317 537.614 85.2317 537.194C84.7634 537.137 84.2884 537.179 83.8376 537.318C83.3867 537.457 82.9701 537.689 82.6148 537.999C82.2596 538.309 81.9736 538.691 81.7757 539.119C81.5777 539.547 81.4721 540.012 81.4657 540.484C81.5421 541.501 81.8398 542.489 82.3379 543.379C82.8361 544.269 83.5227 545.039 84.3497 545.636C85.9877 547.036 90.4397 548.212 90.8037 548.31C90.0999 550.862 89.5667 553.457 89.2077 556.08C88.9977 557.606 88.8157 559.146 88.6757 560.686C88.6757 559.972 88.5917 559.286 88.5777 559.286C88.1717 556.794 85.9037 552.202 83.0897 551.782C82.6229 551.729 82.1503 551.775 81.702 551.915C81.2538 552.056 80.8398 552.288 80.4866 552.598C80.1335 552.908 79.8488 553.288 79.651 553.714C79.4531 554.14 79.3464 554.602 79.3377 555.072C79.4176 556.09 79.7168 557.079 80.2146 557.97C80.7123 558.862 81.397 559.636 82.2217 560.238C84.1349 561.396 86.2115 562.26 88.3817 562.8L88.1997 564.592C87.9617 567.392 87.7377 570.304 87.4297 573.09C87.3177 574.07 87.1777 575.036 87.0377 576.002C87.0377 575.372 87.0377 574.826 87.0377 574.756C86.6177 572.25 84.3497 567.672 81.5497 567.252C81.0821 567.195 80.6078 567.237 80.1576 567.376C79.7075 567.515 79.2917 567.747 78.9375 568.057C78.5834 568.368 78.2988 568.75 78.1023 569.178C77.9059 569.606 77.8021 570.071 77.7977 570.542C77.8641 571.552 78.1488 572.536 78.6322 573.425C79.1156 574.315 79.7862 575.089 80.5977 575.694C82.4799 576.867 84.5351 577.736 86.6877 578.27C86.5057 579.25 86.3377 580.244 86.1277 581.182C85.9737 581.826 85.8617 582.456 85.6657 583.086C85.4697 583.716 85.3017 584.36 85.1337 584.976C84.7417 586.166 84.3497 587.384 83.9577 588.532C83.6777 589.33 83.3977 590.086 83.1177 590.856C83.2437 589.876 83.4397 587.958 83.4257 587.79C83.3231 585.565 82.648 583.405 81.4657 581.518C81.4626 581.269 81.4392 581.021 81.3957 580.776C81.3204 580.311 81.1479 579.868 80.8896 579.475C80.6313 579.081 80.2929 578.747 79.8965 578.493C79.5001 578.24 79.0547 578.072 78.5893 578.003C78.1239 577.933 77.6491 577.962 77.1957 578.088C74.4797 578.914 72.9117 583.772 72.8697 586.306C72.8697 586.46 73.0237 588.084 73.1357 589.106C72.9817 588.518 72.8277 587.93 72.6597 587.328C72.3377 586.124 71.9597 584.934 71.5817 583.66L70.9517 581.812C70.7417 581.182 70.4617 580.552 70.2237 579.922C69.6217 578.452 68.9497 576.996 68.2357 575.554C70.4361 575.011 72.5414 574.138 74.4797 572.964C75.305 572.369 75.9905 571.601 76.4886 570.713C76.9867 569.826 77.2853 568.841 77.3637 567.826C77.3632 567.354 77.2627 566.888 77.0687 566.459C76.8747 566.029 76.5917 565.645 76.2384 565.333C75.8851 565.02 75.4695 564.787 75.0191 564.647C74.5687 564.507 74.0938 564.465 73.6257 564.522C70.8257 564.928 68.5297 569.492 68.1097 571.998C68.1097 572.152 67.9837 573.972 67.9417 574.98C67.5077 574.112 67.0877 573.244 66.6117 572.376C65.2117 569.884 63.8117 567.406 62.4117 564.928L61.1097 562.646C61.4877 562.548 65.9397 561.344 67.5777 560C68.4056 559.406 69.0938 558.639 69.5943 557.751C70.0949 556.864 70.3957 555.878 70.4757 554.862C70.463 554.396 70.3538 553.938 70.1551 553.516C69.9565 553.094 69.6726 552.719 69.3214 552.412C68.9702 552.106 68.5593 551.875 68.1146 551.735C67.6699 551.596 67.2011 551.55 66.7377 551.6C63.9377 552.006 61.6417 556.584 61.2217 559.076C61.2217 559.272 61.0397 561.876 61.0397 562.562C60.0877 560.882 59.1637 559.216 58.2397 557.522C57.0808 555.259 56.0752 552.92 55.2297 550.522C55.3977 550.522 60.0457 549.248 61.7257 547.862C62.5536 547.268 63.2418 546.501 63.7423 545.613C64.2429 544.726 64.5437 543.74 64.6237 542.724C64.621 542.253 64.519 541.788 64.3243 541.359C64.1296 540.931 63.8465 540.548 63.4937 540.236C63.1409 539.924 62.7262 539.69 62.2768 539.55C61.8274 539.409 61.3534 539.365 60.8857 539.42C58.0857 539.826 55.7897 544.404 55.3697 546.896C55.3697 547.064 55.2297 549.066 55.2017 550.018H55.0337C54.2379 547.569 53.6662 545.053 53.3257 542.5C53.1157 541.1 53.0037 539.7 52.9057 538.44C55.1879 538.145 57.4115 537.503 59.4997 536.536C60.4109 536.031 61.198 535.329 61.8035 534.482C62.409 533.634 62.8177 532.662 62.9997 531.636C63.0489 531.168 62.9989 530.695 62.8529 530.248C62.707 529.801 62.4683 529.389 62.1526 529.04C61.8368 528.692 61.4511 528.413 61.0205 528.224C60.5899 528.034 60.1242 527.937 59.6537 527.94C56.8537 528.038 54.0537 532.336 53.3397 534.772C53.3397 534.898 53.0737 536.284 52.9197 537.306C52.9197 536.704 52.8357 536.088 52.8217 535.528C52.7517 533.386 52.8217 531.412 52.8217 529.676C52.8217 528.682 52.9337 527.786 53.0037 526.946C54.916 525.635 56.6117 524.034 58.0297 522.2C58.5884 521.348 58.9543 520.384 59.1018 519.375C59.2493 518.367 59.1749 517.339 58.8837 516.362C58.7083 515.925 58.4432 515.529 58.1056 515.201C57.768 514.872 57.3654 514.618 56.9236 514.454C56.4818 514.291 56.0106 514.221 55.5404 514.251C55.0703 514.281 54.6115 514.408 54.1937 514.626C51.7297 516.026 51.2397 521.108 51.7437 523.586C51.7437 523.796 52.8637 527.072 52.9057 527.044C52.8217 527.842 52.7517 528.71 52.6817 529.648C52.5697 531.384 52.4577 533.358 52.4857 535.514C52.481 537.853 52.6166 540.191 52.8917 542.514C53.1854 545.094 53.7102 547.643 54.4597 550.13C54.4536 550.158 54.4536 550.186 54.4597 550.214C53.9837 549.528 52.6117 547.666 52.4857 547.526C50.7637 545.678 46.3397 543.102 43.7777 544.306C43.3573 544.518 42.9861 544.815 42.6882 545.18C42.3902 545.544 42.1721 545.967 42.048 546.421C41.924 546.875 41.8967 547.35 41.9679 547.816C42.0392 548.281 42.2074 548.726 42.4617 549.122C43.0959 549.93 43.8999 550.588 44.8169 551.05C45.7339 551.512 46.7413 551.767 47.7677 551.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.5419 537.446C47.6139 538.258 52.5419 537.978 52.5419 537.978C52.5419 537.978 51.3519 534.758 51.2539 534.562C50.0779 532.322 46.4939 528.668 43.7079 529.144C43.2554 529.244 42.8284 529.436 42.4535 529.708C42.0785 529.981 41.7637 530.327 41.5286 530.727C41.2935 531.126 41.1431 531.569 41.0869 532.029C41.0307 532.489 41.0699 532.956 41.2019 533.4C41.5849 534.351 42.1721 535.206 42.922 535.906C43.672 536.605 44.5663 537.131 45.5419 537.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.8861 536.76C95.8861 536.76 96.6701 533.428 96.6981 533.204C96.9501 530.698 95.9841 525.672 93.3801 524.524C92.9433 524.349 92.4748 524.267 92.0046 524.284C91.5343 524.3 91.0727 524.415 90.6495 524.621C90.2263 524.827 89.8508 525.119 89.5471 525.478C89.2434 525.837 89.0182 526.256 88.8861 526.708C88.6869 527.709 88.709 528.741 88.9508 529.733C89.1927 530.725 89.6484 531.651 90.2861 532.448C91.5741 534.254 95.8861 536.76 95.8861 536.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.7677 551.796C49.8817 552.02 54.2777 550.578 54.6277 550.466C55.4558 552.976 56.4425 555.431 57.5817 557.816C58.2397 559.216 58.9817 560.616 59.6817 562.016C59.2617 561.442 58.8697 560.924 58.8137 560.868C57.0917 559.006 52.6677 556.43 50.0917 557.634C49.6713 557.846 49.3001 558.143 49.0022 558.508C48.7042 558.872 48.4861 559.295 48.362 559.749C48.238 560.203 48.2107 560.678 48.2819 561.144C48.3532 561.609 48.5214 562.054 48.7757 562.45C49.3997 563.258 50.193 563.92 51.1 564.389C52.0069 564.858 53.0055 565.124 54.0257 565.166C56.2994 565.087 58.5472 564.657 60.6897 563.892C60.9837 564.424 61.2497 564.956 61.5437 565.474C62.9437 567.994 64.3437 570.486 65.5897 572.992C66.0377 573.86 66.4437 574.742 66.8637 575.624C66.4857 575.12 66.1637 574.686 66.1077 574.63C64.3857 572.768 59.9617 570.206 57.3997 571.396C56.9793 571.608 56.6081 571.905 56.3102 572.27C56.0122 572.634 55.7941 573.057 55.67 573.511C55.546 573.965 55.5187 574.44 55.5899 574.906C55.6612 575.371 55.8294 575.816 56.0837 576.212C56.7062 577.018 57.4973 577.679 58.4017 578.148C59.306 578.618 60.3019 578.884 61.3197 578.928C63.5349 578.86 65.7262 578.449 67.8157 577.71C68.2077 578.634 68.6137 579.544 68.9637 580.51C69.1737 581.14 69.4397 581.714 69.6217 582.358C69.8037 583.002 70.0277 583.604 70.2237 584.22C70.5457 585.424 70.9097 586.656 71.2037 587.846C71.4137 588.658 71.5957 589.442 71.7917 590.226C71.3437 589.358 70.3917 587.65 70.3917 587.51C68.9917 585.41 64.9877 582.204 62.2717 583.002C61.8352 583.147 61.4329 583.379 61.0895 583.685C60.7461 583.991 60.4689 584.364 60.2749 584.781C60.0808 585.198 59.9741 585.65 59.9611 586.11C59.9482 586.569 60.0294 587.027 60.1997 587.454C60.6946 588.345 61.3782 589.118 62.2028 589.718C63.0274 590.318 63.9731 590.73 64.9737 590.926C67.3072 591.187 69.6667 591.098 71.9737 590.66C72.2817 591.962 72.5757 593.236 72.8277 594.44C73.7237 598.64 74.2977 602.126 74.6757 604.59L76.5937 604.52V604.296C76.1737 601.818 75.5017 598.276 74.5077 594.076C74.1997 592.746 73.8497 591.276 73.4577 589.876C74.7676 589.305 76.0396 588.65 77.2657 587.916C79.0234 589.327 80.9695 590.487 83.0477 591.36C82.5857 592.62 82.1237 593.838 81.6477 594.986C80.0797 598.962 78.6237 602.21 77.5877 604.464H79.6877C80.6537 602.224 81.8997 599.228 83.2157 595.658C83.6917 594.384 84.1677 592.998 84.6157 591.584C86.92 592.041 89.2811 592.14 91.6157 591.878C92.6176 591.685 93.5652 591.276 94.3923 590.679C95.2193 590.081 95.9058 589.31 96.4037 588.42C96.6038 587.982 96.7072 587.505 96.707 587.023C96.7067 586.541 96.6028 586.065 96.4023 585.627C96.2018 585.189 95.9093 584.799 95.5448 584.484C95.1803 584.168 94.7523 583.935 94.2897 583.8C91.5737 582.988 87.5837 586.194 86.1557 588.28C86.0717 588.406 85.3017 589.834 84.8397 590.758L85.4137 589.008C85.8057 587.832 86.1557 586.642 86.5337 585.354L87.0377 583.464C87.2057 582.834 87.3177 582.148 87.4717 581.476C87.7797 579.936 88.0177 578.354 88.2277 576.758C90.3571 577.518 92.5903 577.948 94.8497 578.032C95.8632 578 96.8576 577.748 97.7641 577.293C98.6705 576.839 99.4675 576.193 100.1 575.4C100.359 575.007 100.533 574.563 100.608 574.098C100.684 573.633 100.66 573.158 100.539 572.702C100.417 572.247 100.2 571.823 99.9023 571.458C99.6047 571.093 99.2329 570.795 98.8117 570.584C96.2357 569.366 91.8117 571.984 90.0897 573.776C89.9777 573.888 88.8857 575.344 88.2977 576.17C88.4097 575.204 88.5357 574.238 88.6197 573.272C88.8717 570.472 89.0397 567.588 89.2077 564.732C89.2077 563.85 89.3337 562.982 89.3897 562.114C89.7537 562.226 94.1217 563.682 96.2497 563.514C97.2677 563.475 98.2648 563.214 99.1716 562.75C100.078 562.286 100.873 561.629 101.5 560.826C101.757 560.431 101.927 559.987 102.001 559.522C102.074 559.057 102.049 558.581 101.926 558.127C101.803 557.672 101.586 557.249 101.288 556.884C100.99 556.519 100.618 556.221 100.198 556.01C97.6357 554.792 93.1977 557.41 91.4757 559.202C91.3497 559.342 89.7817 561.442 89.4037 562.002C89.5437 560.084 89.6837 558.166 89.9217 556.29C90.2307 553.748 90.6983 551.228 91.3217 548.744C91.5037 548.814 96.0537 550.34 98.2237 550.144C99.2417 550.105 100.239 549.844 101.146 549.38C102.052 548.916 102.847 548.259 103.474 547.456C103.756 547.059 103.949 546.605 104.038 546.126C104.127 545.647 104.11 545.154 103.989 544.682C103.868 544.21 103.645 543.77 103.336 543.393C103.027 543.016 102.639 542.711 102.2 542.5C99.6377 541.282 95.1997 543.9 93.4777 545.692C93.3657 545.804 92.1617 547.414 91.6157 548.198L91.4617 548.128C92.1767 545.645 93.1138 543.232 94.2617 540.918C94.8637 539.63 95.5077 538.44 96.1517 537.292C98.2217 538.296 100.43 538.985 102.704 539.336C103.721 539.409 104.741 539.259 105.694 538.896C106.647 538.533 107.509 537.967 108.22 537.236C108.519 536.873 108.737 536.45 108.862 535.997C108.987 535.543 109.014 535.068 108.943 534.603C108.872 534.138 108.703 533.693 108.448 533.298C108.193 532.902 107.858 532.565 107.464 532.308C105.056 530.824 100.366 532.868 98.4477 534.52C98.3357 534.604 97.3697 535.64 96.6837 536.396C96.9917 535.878 97.2857 535.346 97.5937 534.856C98.7137 533.036 99.8617 531.426 100.87 530.012C101.458 529.214 102.004 528.514 102.522 527.856C104.814 527.798 107.085 527.392 109.256 526.652C110.191 526.247 111.026 525.642 111.703 524.88C112.38 524.118 112.883 523.218 113.176 522.242C113.272 521.782 113.271 521.308 113.172 520.849C113.073 520.39 112.879 519.956 112.602 519.577C112.324 519.198 111.97 518.882 111.563 518.649C111.155 518.416 110.703 518.271 110.236 518.224C107.436 518.014 104.188 521.99 103.236 524.342C103.152 524.538 102.228 527.87 102.284 527.856C101.78 528.486 101.234 529.158 100.66 529.914C99.6097 531.314 98.4337 532.882 97.2577 534.688C95.9823 536.627 94.8184 538.637 93.7717 540.708C92.5939 543.021 91.6241 545.434 90.8737 547.918C90.8755 547.951 90.8755 547.983 90.8737 548.016C90.8737 547.19 90.7477 544.866 90.7057 544.684C90.2997 542.192 88.0317 537.614 85.2317 537.194C84.7634 537.137 84.2884 537.179 83.8376 537.318C83.3867 537.457 82.9701 537.689 82.6148 537.999C82.2596 538.309 81.9736 538.691 81.7757 539.119C81.5777 539.547 81.4721 540.012 81.4657 540.484C81.5421 541.501 81.8398 542.489 82.3379 543.379C82.8361 544.269 83.5227 545.039 84.3497 545.636C85.9877 547.036 90.4397 548.212 90.8037 548.31C90.0999 550.862 89.5667 553.457 89.2077 556.08C88.9977 557.606 88.8157 559.146 88.6757 560.686C88.6757 559.972 88.5917 559.286 88.5777 559.286C88.1717 556.794 85.9037 552.202 83.0897 551.782C82.6229 551.729 82.1503 551.775 81.702 551.915C81.2538 552.056 80.8398 552.288 80.4866 552.598C80.1335 552.908 79.8488 553.288 79.651 553.714C79.4531 554.14 79.3464 554.602 79.3377 555.072C79.4176 556.09 79.7168 557.079 80.2146 557.97C80.7123 558.862 81.397 559.636 82.2217 560.238C84.1349 561.396 86.2115 562.26 88.3817 562.8L88.1997 564.592C87.9617 567.392 87.7377 570.304 87.4297 573.09C87.3177 574.07 87.1777 575.036 87.0377 576.002C87.0377 575.372 87.0377 574.826 87.0377 574.756C86.6177 572.25 84.3497 567.672 81.5497 567.252C81.0821 567.195 80.6078 567.237 80.1576 567.376C79.7075 567.515 79.2917 567.747 78.9375 568.057C78.5834 568.368 78.2988 568.75 78.1023 569.178C77.9059 569.606 77.8021 570.071 77.7977 570.542C77.8641 571.552 78.1488 572.536 78.6322 573.425C79.1156 574.315 79.7862 575.089 80.5977 575.694C82.4799 576.867 84.5351 577.736 86.6877 578.27C86.5057 579.25 86.3377 580.244 86.1277 581.182C85.9737 581.826 85.8617 582.456 85.6657 583.086C85.4697 583.716 85.3017 584.36 85.1337 584.976C84.7417 586.166 84.3497 587.384 83.9577 588.532C83.6777 589.33 83.3977 590.086 83.1177 590.856C83.2437 589.876 83.4397 587.958 83.4257 587.79C83.3231 585.565 82.648 583.405 81.4657 581.518C81.4626 581.269 81.4392 581.021 81.3957 580.776C81.3204 580.311 81.1479 579.868 80.8896 579.475C80.6313 579.081 80.2929 578.747 79.8965 578.493C79.5001 578.24 79.0547 578.072 78.5893 578.003C78.1239 577.933 77.6491 577.962 77.1957 578.088C74.4797 578.914 72.9117 583.772 72.8697 586.306C72.8697 586.46 73.0237 588.084 73.1357 589.106C72.9817 588.518 72.8277 587.93 72.6597 587.328C72.3377 586.124 71.9597 584.934 71.5817 583.66L70.9517 581.812C70.7417 581.182 70.4617 580.552 70.2237 579.922C69.6217 578.452 68.9497 576.996 68.2357 575.554C70.4361 575.011 72.5414 574.138 74.4797 572.964C75.305 572.369 75.9905 571.601 76.4886 570.713C76.9867 569.826 77.2853 568.841 77.3637 567.826C77.3632 567.354 77.2627 566.888 77.0687 566.459C76.8747 566.029 76.5917 565.645 76.2384 565.333C75.8851 565.02 75.4695 564.787 75.0191 564.647C74.5687 564.507 74.0938 564.465 73.6257 564.522C70.8257 564.928 68.5297 569.492 68.1097 571.998C68.1097 572.152 67.9837 573.972 67.9417 574.98C67.5077 574.112 67.0877 573.244 66.6117 572.376C65.2117 569.884 63.8117 567.406 62.4117 564.928L61.1097 562.646C61.4877 562.548 65.9397 561.344 67.5777 560C68.4056 559.406 69.0938 558.639 69.5943 557.751C70.0949 556.864 70.3957 555.878 70.4757 554.862C70.463 554.396 70.3538 553.938 70.1551 553.516C69.9565 553.094 69.6726 552.719 69.3214 552.412C68.9702 552.106 68.5593 551.875 68.1146 551.735C67.6699 551.596 67.2011 551.55 66.7377 551.6C63.9377 552.006 61.6417 556.584 61.2217 559.076C61.2217 559.272 61.0397 561.876 61.0397 562.562C60.0877 560.882 59.1637 559.216 58.2397 557.522C57.0808 555.259 56.0752 552.92 55.2297 550.522C55.3977 550.522 60.0457 549.248 61.7257 547.862C62.5536 547.268 63.2418 546.501 63.7423 545.613C64.2429 544.726 64.5437 543.74 64.6237 542.724C64.621 542.253 64.519 541.788 64.3243 541.359C64.1296 540.931 63.8465 540.548 63.4937 540.236C63.1409 539.924 62.7262 539.69 62.2768 539.55C61.8274 539.409 61.3534 539.365 60.8857 539.42C58.0857 539.826 55.7897 544.404 55.3697 546.896C55.3697 547.064 55.2297 549.066 55.2017 550.018H55.0337C54.2379 547.569 53.6662 545.053 53.3257 542.5C53.1157 541.1 53.0037 539.7 52.9057 538.44C55.1879 538.145 57.4115 537.503 59.4997 536.536C60.4109 536.031 61.198 535.329 61.8035 534.482C62.409 533.634 62.8177 532.662 62.9997 531.636C63.0489 531.168 62.9989 530.695 62.8529 530.248C62.707 529.801 62.4683 529.389 62.1526 529.04C61.8368 528.692 61.4511 528.413 61.0205 528.224C60.5899 528.034 60.1242 527.937 59.6537 527.94C56.8537 528.038 54.0537 532.336 53.3397 534.772C53.3397 534.898 53.0737 536.284 52.9197 537.306C52.9197 536.704 52.8357 536.088 52.8217 535.528C52.7517 533.386 52.8217 531.412 52.8217 529.676C52.8217 528.682 52.9337 527.786 53.0037 526.946C54.916 525.635 56.6117 524.034 58.0297 522.2C58.5884 521.348 58.9543 520.384 59.1018 519.375C59.2493 518.367 59.1749 517.339 58.8837 516.362C58.7083 515.925 58.4432 515.529 58.1056 515.201C57.768 514.872 57.3654 514.618 56.9236 514.454C56.4818 514.291 56.0106 514.221 55.5404 514.251C55.0703 514.281 54.6115 514.408 54.1937 514.626C51.7297 516.026 51.2397 521.108 51.7437 523.586C51.7437 523.796 52.8637 527.072 52.9057 527.044C52.8217 527.842 52.7517 528.71 52.6817 529.648C52.5697 531.384 52.4577 533.358 52.4857 535.514C52.481 537.853 52.6166 540.191 52.8917 542.514C53.1854 545.094 53.7102 547.643 54.4597 550.13C54.4536 550.158 54.4536 550.186 54.4597 550.214C53.9837 549.528 52.6117 547.666 52.4857 547.526C50.7637 545.678 46.3397 543.102 43.7777 544.306C43.3573 544.518 42.9861 544.815 42.6882 545.18C42.3902 545.544 42.1721 545.967 42.048 546.421C41.924 546.875 41.8967 547.35 41.9679 547.816C42.0392 548.281 42.2074 548.726 42.4617 549.122C43.0959 549.93 43.8999 550.588 44.8169 551.05C45.7339 551.512 46.7413 551.767 47.7677 551.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8878 601.986H70.8398V621.544H83.8878V601.986Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M618.8 183.162H588V198.562H618.8V183.162Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M658.518 183.162H627.718V198.562H658.518V183.162Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M638.246 202.622H607.446V218.022H638.246V202.622Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M638.246 162.078H607.446V177.478H638.246V162.078Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M618.8 240.716H588V256.116H618.8V240.716Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M658.518 240.716H627.718V256.116H658.518V240.716Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M658.518 77H627.718V92.4H658.518V77Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M620.718 127.4H589.918V142.8H620.718V127.4Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M589.4 92.4H558.6V107.8H589.4V92.4Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M568.204 68.348H537.404V83.748H568.204V68.348Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M638.246 260.176H607.446V275.576H638.246V260.176Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M450.646 294.07H419.846V309.47H450.646V294.07Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M490.364 294.07H459.564V309.47H490.364V294.07Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M527.506 313.53H496.706V328.93H527.506V313.53Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M538.79 91.042H394.156V281.092H538.79V91.042Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M487.788 91H458.122L394.156 154.966V204.106L457.674 140.588L457.198 121.59L487.788 91ZM538.79 91H536.928L421.974 205.954L445.2 229.166L394.198 280.168V281.092H431.2L492.8 219.492H466.48L448.168 201.18L538.79 110.558V91ZM538.79 130.396L466.2 203L486.822 203.224L538.748 255.15V231.49L493.08 185.836L538.748 140.168L538.79 130.396ZM502.6 231.952L453.46 281.092H488.698L520.212 249.564L502.6 231.952ZM394.156 91V112.364L415.478 91H394.156Z",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.2 66.276H126V339.724H340.2V66.276Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8 77H134.4V329H331.8V77Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8 201.6H134.4V215.6H331.8V201.6Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.722 90.3L282.744 131.264",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.954 158.452L262.682 164.724",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.288 132.104L275.646 151.76",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.836 91.9661L151.872 104.93",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.51 265.496L279.398 272.594",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.524 237.482L292.782 259.224",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.722 226.1L282.744 267.064",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.954 294.252L262.682 300.524",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.288 267.904L275.646 287.56",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.836 227.766L151.872 240.73",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.51 401.296L279.398 408.394",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.524 373.282L292.782 395.024",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M570.276 612.136C570.276 612.136 568.876 594.902 570.276 584.374C571.676 573.846 578.41 570.01 578.886 565.222C579.362 560.434 576.492 555.646 579.376 550.858C581.843 547.182 584.733 543.808 587.986 540.806C587.986 540.806 584.164 547.988 587.034 553.728C589.904 559.468 594.356 565.698 591.332 570.528C588.308 575.358 585.116 580.104 586.068 583.94C587.02 587.776 592.298 586.81 591.332 595.42C590.366 604.03 587.986 607.39 587.986 607.39L588.462 612.178L572.194 611.702",
    fill: "#1B5FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M570.276 612.136C570.276 612.136 568.876 594.902 570.276 584.374C571.676 573.846 578.41 570.01 578.886 565.222C579.362 560.434 576.492 555.646 579.376 550.858C581.843 547.182 584.733 543.808 587.986 540.806C587.986 540.806 584.164 547.988 587.034 553.728C589.904 559.468 594.356 565.698 591.332 570.528C588.308 575.358 585.116 580.104 586.068 583.94C587.02 587.776 592.298 586.81 591.332 595.42C590.366 604.03 587.986 607.39 587.986 607.39L588.462 612.178L572.194 611.702",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M569.016 611.94C569.016 611.94 572.418 608.37 566.902 602.98C563.332 599.494 559.832 594.314 559.664 588.98C559.58 586.334 560.784 584.234 559.972 581.756C559.09 579.054 556.332 577.346 555.576 574.336C554.176 568.526 558.026 563.136 558.502 561.246C558.978 559.356 558.502 559.272 555.912 554.148C554.362 551.199 553.518 547.931 553.448 544.6C553.916 546.269 554.825 547.782 556.079 548.979C557.332 550.176 558.885 551.014 560.574 551.404C566.594 552.972 570.038 556.836 569.618 564.158C569.198 571.48 568.708 573.314 573.818 574.644C581.826 576.744 581.028 582.246 580.132 588.966C579.558 593.166 579.334 594.272 581.826 597.366C583.856 599.844 587.006 599.424 584.542 603.708C581.826 608.44 585.732 612.43 580.958 613.662C576.184 614.894 569.016 611.94 569.016 611.94Z",
    fill: "#1B5FAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M589.204 612.738C589.204 612.738 585.9 609.07 591.57 603.834C595.224 600.446 598.864 595.364 599.186 590.002C599.34 587.356 598.206 585.214 599.088 582.778C600.054 580.104 602.854 578.466 603.68 575.484C605.29 569.702 601.566 564.186 601.132 562.31C600.698 560.434 601.132 560.35 603.932 555.31C605.563 552.405 606.494 549.16 606.648 545.832C606.135 547.49 605.184 548.98 603.895 550.143C602.607 551.306 601.028 552.099 599.326 552.44C593.264 553.84 589.722 557.606 589.932 564.928C590.142 572.25 590.59 574.112 585.452 575.302C577.388 577.164 578.018 582.694 578.732 589.442C579.18 593.642 579.376 594.776 576.8 597.744C574.7 600.166 571.578 599.662 573.916 604.016C576.492 608.818 572.516 612.696 577.22 614.054C581.924 615.412 589.204 612.738 589.204 612.738Z",
    fill: "#1B5FAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M599.62 608.3V632.8C599.625 633.268 599.602 633.735 599.55 634.2C599.448 635.477 599.175 636.734 598.738 637.938C597.676 640.939 595.71 643.538 593.11 645.376C590.51 647.213 587.404 648.2 584.22 648.2H575.82C572.653 648.18 569.569 647.184 566.989 645.347C564.408 643.511 562.457 640.924 561.4 637.938C560.964 636.734 560.691 635.477 560.588 634.2C560.537 633.735 560.513 633.268 560.518 632.8V608.3H599.62Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M599.62 625.8H560.462V626.724H599.62V625.8Z",
    fill: "#263238",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M599.55 631.946C599.448 633.223 599.175 634.48 598.738 635.684H561.4C560.964 634.48 560.691 633.223 560.588 631.946H599.55Z",
    fill: "#263238",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9399 238.63L55.6359 408.282",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1017 384.272L45.2197 375.984",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8237 378.7C47.805 377.315 47.4905 375.951 46.9014 374.698C46.3122 373.445 45.462 372.332 44.4077 371.434C42.2097 369.46 30.6457 364.602 29.5397 368.634C28.3497 373.1 40.1937 381.808 47.8237 378.7Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8237 378.7L36.8057 371.826",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0618 402.976L47.3618 396.578",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9659 399.294C49.9557 397.905 49.6465 396.535 49.0595 395.276C48.4725 394.018 47.6213 392.9 46.5639 392C44.3659 390.026 32.7879 385.168 31.6959 389.2C30.4919 393.694 42.3359 402.402 49.9659 399.294Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9658 399.294L38.9478 392.42",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7537 332.738L39.9697 325.738",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5737 328.454C42.5629 327.072 42.2562 325.709 41.6742 324.455C41.0922 323.202 40.2485 322.088 39.1997 321.188C37.0017 319.214 25.4237 314.356 24.3317 318.388C23.0997 322.854 34.9997 331.562 42.5737 328.454Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5737 328.454L31.5557 321.58",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.924 354.634L42.126 346.332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8001 349.048C44.7813 347.663 44.4669 346.299 43.8777 345.046C43.2886 343.792 42.4384 342.68 41.3841 341.782C39.1861 339.808 27.6221 334.95 26.5161 338.982C25.2001 343.448 37.1001 352.156 44.8001 349.048Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7299 349.048L33.7119 342.174",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2819 300.244L36.4839 292.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0878 295.008C39.069 293.623 38.7546 292.259 38.1654 291.006C37.5763 289.753 36.726 288.64 35.6718 287.742C33.4738 285.768 21.9098 280.91 20.8038 284.942C19.5998 289.408 31.4578 298.116 39.0878 295.008Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0878 295.008L28.0698 288.134",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5297 264.474L32.9697 258.692",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5739 261.408C35.5631 260.026 35.2563 258.663 34.6743 257.409C34.0923 256.156 33.2486 255.042 32.1999 254.142C30.0019 252.182 18.4239 247.31 17.3319 251.342C16.1139 255.822 27.9999 264.516 35.5739 261.408Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5738 261.408L24.5698 254.548",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3457 372.848L58.8557 362.222",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8679 365.4C56.5996 364.042 56.6245 362.643 56.9408 361.296C57.2571 359.949 57.8575 358.684 58.7019 357.588C60.4519 355.222 70.7699 348.068 72.7019 351.82C74.7739 355.922 64.9739 366.898 56.8679 365.4Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8677 365.414L64.6237 358.148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6899 318.668L53.1999 308.042",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2117 311.234C50.9434 309.876 50.9682 308.477 51.2845 307.13C51.6008 305.783 52.2013 304.518 53.0457 303.422C54.7957 301.042 62.8457 295.092 64.7777 298.858C66.8637 302.946 59.3177 312.704 51.2117 311.234Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2119 311.234L61.1379 301.756",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1978 294.854L50.7218 284.228",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7336 287.42C48.4654 286.062 48.4902 284.663 48.8065 283.316C49.1228 281.969 49.7232 280.704 50.5676 279.608C52.3176 277.228 62.6216 270.074 64.5676 273.84C66.6256 277.928 56.8396 288.89 48.7336 287.42Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7339 287.42L58.6459 277.942",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5576 259.938L47.0676 249.326",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0799 252.504C44.8117 251.145 44.8379 249.745 45.1567 248.398C45.4755 247.05 46.0794 245.786 46.9279 244.692C48.6639 242.326 58.9819 235.172 60.9279 238.924C62.9999 243.026 53.1999 253.988 45.0799 252.504Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0801 252.504L55.0061 243.026",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 237.622C37.5318 236.264 37.5566 234.865 37.8729 233.518C38.1892 232.171 38.7896 230.906 39.634 229.81C41.384 227.43 51.702 220.276 53.634 224.042C55.678 228.2 45.878 239.092 37.8 237.622Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.772 237.622L47.698 228.144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3459 238C36.9742 238.126 35.5915 237.958 34.2901 237.506C32.9887 237.055 31.7988 236.331 30.7999 235.382C28.6159 233.408 22.5959 222.39 26.5299 220.878C30.7999 219.24 40.6699 230.118 38.3459 238Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.346 238.028L29.96 227.178",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2339 189.826V407.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7658 263.564L72.7158 408.702",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9541 407.638L68.6001 402.668",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5998 402.668C68.8765 401.302 68.8559 399.892 68.5394 398.534C68.223 397.177 67.6181 395.903 66.7658 394.8C65.0158 392.42 54.6978 385.28 52.7658 389.032C50.6938 393.19 60.4938 404.138 68.5998 402.668Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5999 402.668L59.2339 393.68",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2597 355.936L71.8057 350.546",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8218 352.422C74.0899 351.063 74.0637 349.663 73.745 348.316C73.4262 346.968 72.8222 345.704 71.9738 344.61C70.2378 342.23 59.9058 335.076 57.9738 338.842C55.9158 343 65.7158 353.892 73.8218 352.422Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8221 352.422L64.4561 343.434",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2159 380.436L69.6919 369.824",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6799 373.002C71.9482 371.644 71.9234 370.245 71.6071 368.898C71.2908 367.551 70.6903 366.286 69.8459 365.19C68.0959 362.824 57.7779 355.67 55.8459 359.436C53.7739 363.524 63.5739 374.486 71.6799 373.002Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.68 373.002L62.314 364.028",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5217 322.952L75.3057 315.77",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2939 318.962C77.5621 317.603 77.5359 316.203 77.2171 314.856C76.8984 313.508 76.2944 312.244 75.4459 311.15C73.6959 308.784 63.3779 301.63 61.4459 305.396C59.3879 309.484 69.1879 320.446 77.2939 318.962Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2937 318.962L67.9277 309.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.798 291.508L78.792 282.184",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7798 285.362C81.0479 284.003 81.0218 282.603 80.703 281.256C80.3842 279.908 79.7802 278.644 78.9318 277.55C77.1818 275.184 66.8638 268.03 64.9318 271.796C62.8738 275.884 72.6738 286.846 80.7798 285.362Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7801 285.362L71.4141 276.388",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.228 397.88L82.796 388.822",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1919 391.538C80.2142 390.155 80.5289 388.793 81.1153 387.541C81.7016 386.289 82.5463 385.175 83.5939 384.272C85.7919 382.298 97.3699 377.426 98.4619 381.472C99.6659 385.938 87.8219 394.646 80.1919 391.538Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1919 391.538L91.8539 384.3",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M79.856 343.686L88.424 334.628",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8198 337.4C85.8341 336.016 86.1452 334.651 86.7321 333.398C87.319 332.144 88.168 331.031 89.2218 330.134C91.4198 328.174 102.984 323.288 104.09 327.334C105.28 331.8 93.4498 340.452 85.8198 337.4Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8198 337.344L97.4818 330.106",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M82.334 319.872L90.888 310.814",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2837 313.6C88.3024 312.215 88.6169 310.851 89.206 309.598C89.7952 308.345 90.6454 307.232 91.6997 306.334C93.8977 304.374 105.462 299.488 106.554 303.534C107.8 308 95.9137 316.638 88.2837 313.6Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2837 313.53L99.9457 306.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8477 283.178L94.5137 275.912",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 278.6C91.9249 277.216 92.2363 275.852 92.8232 274.598C93.41 273.345 94.2585 272.232 95.3117 271.334C97.5097 269.374 109.088 264.502 110.18 268.534C111.384 273 99.5397 281.736 91.9097 278.6Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9097 278.614L103.572 271.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8218 262.542C87.8361 261.158 88.1471 259.793 88.734 258.54C89.3209 257.286 90.17 256.173 91.2238 255.276C93.4218 253.316 104.986 248.444 106.092 252.476C107.296 256.942 95.4518 265.65 87.8218 262.542Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8218 262.542L99.4838 255.304",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M88.298 263.06C86.918 262.894 85.5899 262.433 84.4038 261.708C83.2177 260.984 82.2014 260.012 81.424 258.86C79.702 256.466 76.076 244.454 80.234 243.782C84.77 243.11 92.19 255.808 88.298 263.06Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2978 263.06L82.3198 250.712",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9258 383.95L58.8418 374.486",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 377.454C61.2785 376.074 61.1078 374.682 60.6514 373.373C60.195 372.064 59.4633 370.868 58.5058 369.866C56.5318 367.696 45.5278 361.648 44.0158 365.582C42.3638 369.866 53.1998 379.764 61.1518 377.454Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 377.454L50.9038 369.474",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1778 338.282L58.8418 331.45",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 334.418C61.2782 333.04 61.1075 331.65 60.651 330.344C60.1945 329.037 59.463 327.844 58.5058 326.844C56.5318 324.66 45.5278 318.612 44.0158 322.56C42.3638 326.844 53.1998 336.728 61.1518 334.418Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 334.418L50.9038 326.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4158 290.822L58.8418 280.938",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 283.906C61.2785 282.526 61.1078 281.134 60.6514 279.825C60.195 278.516 59.4633 277.32 58.5058 276.318C56.5318 274.148 45.5278 268.1 44.0158 272.034C42.3638 276.318 53.1998 286.216 61.1518 283.906Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 283.906L50.9038 275.926",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9258 253.694L58.8418 247.31",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 250.278C61.2785 248.898 61.1078 247.506 60.6514 246.197C60.195 244.888 59.4633 243.692 58.5058 242.69C56.5318 240.506 45.5278 234.472 44.0158 238.406C42.3638 242.69 53.1998 252.574 61.1518 250.278Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 250.278L50.9038 242.298",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3319 220.052L58.9819 214.662",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 216.496C61.2782 215.118 61.1075 213.728 60.651 212.422C60.1945 211.115 59.463 209.922 58.5058 208.922C56.5318 206.738 45.5278 200.69 44.0158 204.624C42.3638 208.922 53.1998 218.806 61.1518 216.496Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1518 216.496L50.9038 208.53",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7178 395.388L73.8358 387.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M71.526 390.6C71.403 389.218 71.578 387.825 72.0393 386.516C72.5006 385.207 73.2374 384.012 74.2 383.012C76.188 380.828 87.192 374.78 88.704 378.728C90.314 383.012 79.436 392.896 71.526 390.6Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 390.586L82.3759 382.186",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M66.248 329.084L73.836 319.186",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5258 322.154C71.4049 320.774 71.5809 319.384 72.0422 318.077C72.5034 316.771 73.2391 315.578 74.1998 314.58C76.1878 312.396 87.1918 306.348 88.7038 310.296C90.3138 314.58 79.4358 324.464 71.5258 322.154Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 322.154L82.3759 313.754",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M66.248 295.302L73.836 285.418",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5256 288.4C71.4006 287.015 71.5747 285.62 72.036 284.308C72.4974 282.997 73.2352 281.8 74.1996 280.798C76.1876 278.614 87.1916 272.58 88.7036 276.514C90.3136 280.798 79.4356 290.682 71.5256 288.4Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 288.372L82.3759 279.972",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M66.248 250.656L73.836 240.772",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 243.74C71.4093 242.358 71.5874 240.967 72.0483 239.659C72.5093 238.351 73.2426 237.156 74.1999 236.152C76.1879 233.968 87.1919 227.934 88.7039 231.868C90.3139 236.152 79.4359 246.036 71.5259 243.74Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 243.74L82.3759 235.34",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M66.584 212.128L74.018 206.332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M71.526 208.6C71.4092 207.224 71.5873 205.84 72.0484 204.538C72.5095 203.237 73.2431 202.049 74.2 201.054C76.188 198.87 87.192 192.836 88.704 196.77C90.314 201.054 79.436 210.938 71.526 208.6Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5259 208.628L82.3759 200.228",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7999 193.074C65.6778 191.695 65.8492 190.306 66.3029 188.998C66.7566 187.69 67.4822 186.493 68.4319 185.486C70.4199 183.302 81.4239 177.268 82.9359 181.202C84.5879 185.486 73.7099 195.37 65.7999 193.074Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7998 193.074L76.6498 184.674",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3318 193.536C64.9472 193.517 63.5826 193.203 62.3294 192.614C61.0763 192.025 59.9635 191.174 59.0658 190.12C57.1058 187.922 52.2478 176.344 56.2658 175.252C60.7598 174.062 69.4538 185.906 66.3318 193.536Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3319 193.536L59.1079 181.86",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M576.534 263.088C576.534 263.088 543.718 278.768 537.334 288.288C534.534 292.418 515.858 367.052 515.858 367.052L503.482 377.37L522.452 410.97H635.11C635.11 410.97 643.356 294.77 641.704 289.03C640.052 283.29 600.88 266.392 596.4 264.32C591.92 262.248 580.258 261.016 576.534 263.088Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M561.624 347.634L582.568 364.924L565.992 355.572",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M553.238 340.704L558.306 344.89",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M442.47 392C442.47 392 438.578 392.588 437.024 395.108C435.47 397.628 432.544 404.838 433.902 405.426C435.26 406.014 436.24 403.872 437.22 402.318C438.2 400.764 439.544 398.426 439.544 398.426L442.666 397.838L442.47 392Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M447.916 388.248C447.916 388.248 443.436 387.856 442.316 389.802C441.196 391.748 438.816 404.586 439.012 406.154C439.208 407.722 441.154 408.478 442.708 405.762C444.262 403.046 447.566 390.978 447.566 390.978L447.916 388.248Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M457.058 388.052C457.058 388.052 450.45 384.944 447.72 385.532C444.99 386.12 441.112 405.958 441.686 406.924C441.985 407.197 442.338 407.404 442.721 407.533C443.105 407.662 443.511 407.71 443.914 407.673C444.318 407.636 444.709 407.516 445.063 407.319C445.416 407.123 445.726 406.855 445.97 406.532C446.936 404.978 452.578 395.444 454.146 393.12C455.207 391.484 456.179 389.792 457.058 388.052Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M525 398.23C525 398.23 522.466 380.982 517.846 374.262C513.226 367.542 509.81 373.324 502.824 376.964C498.624 379.176 473.256 389.816 472.024 390.236C470.792 390.656 459.83 384.342 457.73 386.036C455.63 387.73 447.636 397.81 445.956 403.27C444.276 408.73 448.476 409.164 450.156 407.47C451.836 405.776 456.89 397.796 458.99 396.116C461.09 394.436 466.144 399.896 466.144 399.896C466.144 399.896 458.57 403.676 456.05 405.37C453.53 407.064 457.31 407.89 461.51 407.89C465.727 407.713 469.869 406.714 473.704 404.95L477.904 402.836C477.904 402.836 511.07 402.85 525 398.23Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M579.012 154.154C579.012 154.154 546.42 168.154 543.522 177.674C540.624 187.194 546.826 188.398 547.652 193.354C548.478 198.31 525.784 221.354 534.87 235.858C543.956 250.362 593.46 254.058 614.082 250.292C634.704 246.526 647.92 232.092 646.688 215.628C645.456 199.164 635.488 191.282 623.168 172.718C610.848 154.154 587.678 151.27 579.012 154.154Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M555.492 213.57C555.492 213.57 550.13 213.99 550.13 218.106C550.13 222.222 555.492 230.902 557.97 230.482C560.448 230.062 555.492 213.57 555.492 213.57Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M572.824 177.674C572.824 177.674 553.84 190.876 554.26 198.31C554.68 205.744 553.434 224.294 559.622 236.684C563.994 245.135 568.958 253.265 574.476 261.016C574.476 261.016 570.766 293.216 571.172 301.462C571.578 309.708 578.172 305.592 585.62 296.506C593.068 287.42 600.474 267.218 600.474 267.218L595.938 261.8L596.764 255.206C596.764 255.206 606.662 246.54 609.546 239.106C611.114 235.102 610.792 226.324 610.792 226.324C612.409 225.635 613.865 224.618 615.07 223.339C616.274 222.06 617.201 220.545 617.792 218.89L619.444 213.528C615.748 211.675 612.163 209.609 608.706 207.34C604.368 203.849 600.235 200.11 596.33 196.14C596.33 196.14 579.432 187.6 572.824 177.674Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M571.998 207.788C571.998 207.788 569.94 228.788 572.418 233.38C574.896 237.972 581.49 233.38 581.49 233.38",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M574 242.046C574 242.046 584.738 244.104 590.506 236.684",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M586.852 212.744C588.221 212.744 589.33 211.359 589.33 209.65C589.33 207.941 588.221 206.556 586.852 206.556C585.483 206.556 584.374 207.941 584.374 209.65C584.374 211.359 585.483 212.744 586.852 212.744Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M563.752 212.744C565.121 212.744 566.23 211.359 566.23 209.65C566.23 207.941 565.121 206.556 563.752 206.556C562.384 206.556 561.274 207.941 561.274 209.65C561.274 211.359 562.384 212.744 563.752 212.744Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M582.316 198.31C582.316 198.31 588.504 195.832 592.214 199.542",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M568.288 198.716C568.288 198.716 562.1 195.832 559.622 201.6",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M537.474 333.564L542.612 360.794L532.098 400.33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M535.472 322.938L536.326 327.502",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M631.834 281.246C631.834 281.246 644.77 287.294 644.056 291.48C643.342 295.666 647.15 387.968 642.656 394.324C638.162 400.68 625.646 398.524 625.646 398.524C625.646 398.524 620.326 381.962 614.894 376.95C609.462 371.938 607.474 373.646 607.474 373.646L611.184 317.52",
    fill: "#1B5FAD"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M631.834 281.246C631.834 281.246 644.77 287.294 644.056 291.48C643.342 295.666 647.15 387.968 642.656 394.324C638.162 400.68 625.646 398.524 625.646 398.524C625.646 398.524 620.326 381.962 614.894 376.95C609.462 371.938 607.474 373.646 607.474 373.646L611.184 317.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M511.406 393.148C509.554 395.408 507.346 397.351 504.868 398.902C501.032 401.212 496.034 402.36 499.492 403.9C502.95 405.44 508.326 403.13 511.406 401.212C514.486 399.294 511.406 393.148 511.406 393.148Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M588.462 385.476C596.862 380.352 604.394 371.826 614.852 371.476C625.31 371.126 634.942 378.476 639.562 387.324C641.074 390.222 642.124 393.624 641.172 396.746C639.394 402.626 632.044 404.334 625.954 405.048L592.354 409.038C572.222 411.418 551.026 413.658 532.35 405.762C532.106 407.545 531.314 409.209 530.082 410.522C528.682 411.684 526.204 411.628 525.504 409.99C524.775 410.674 523.835 411.091 522.838 411.172C521.842 411.253 520.847 410.995 520.016 410.438C519.666 410.228 517.874 411.152 516.012 410.83C515.354 410.704 513.058 409.696 512.4 409.542C511.962 409.491 511.538 409.353 511.154 409.137C510.769 408.92 510.432 408.63 510.16 408.282C509.887 407.726 509.771 407.107 509.824 406.49C509.591 402.526 509.969 398.551 510.944 394.702C515.676 379.526 532.616 387.842 541.618 393.806C544.684 395.836 547.918 397.922 551.572 398.272C554.312 398.356 557.044 397.943 559.636 397.054C569.31 394.352 579.516 390.95 588.364 385.616L588.462 385.476Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M532.294 405.72L533.75 400.008",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M525.616 409.276C525.616 409.276 526.386 393.526 529.074 390.068",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M520.24 409.654C520.24 409.654 519.078 395.836 521.766 389.298",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M514.416 409.598C514.416 409.598 513.324 399.028 515.242 391.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2802 411.208L38.7802 312.774C38.7014 312.046 38.7772 311.309 39.0025 310.612C39.2278 309.915 39.5977 309.273 40.0879 308.729C40.578 308.185 41.1776 307.75 41.8472 307.453C42.5169 307.156 43.2417 307.004 43.9742 307.006H111.832C113.021 307.004 114.174 307.408 115.101 308.152C116.028 308.895 116.673 309.933 116.928 311.094L139.104 411.208H49.2802Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M132.258 244.272C132.258 244.272 89.4601 267.036 88.2841 276.066C87.1081 285.096 83.5801 411.054 83.5801 411.054H195.846C195.846 411.054 184.856 361.648 183.68 355.754C182.504 349.86 180.88 339.668 180.88 339.668L217.868 356.468L223.356 319.578C223.356 319.578 204.036 291.76 191.87 276.444C179.704 261.128 163.996 249.354 156.87 247.786C149.744 246.218 132.258 244.272 132.258 244.272Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M180.936 339.668L183.05 321.664L188.986 300.664",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M183.05 321.664L184.24 303.044",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M169.932 347.802C170.94 348.208 171.892 348.614 172.732 349.02",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M131.516 336.728C131.516 336.728 151.382 341.292 165.116 345.996",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M155.694 291.55C155.694 291.55 157.682 322.854 158.494 324.842C159.306 326.83 163.646 325.234 163.646 325.234L160.846 307.034",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M120.61 310.058L123.592 305.816",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M108.528 327.222L117.614 314.314",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M145.124 235.2C145.124 235.2 132.524 238 130.214 240.296C127.904 242.592 123.928 257.18 123.928 257.18L130.928 294.084C130.928 294.084 150.948 276.416 153.692 275.632C156.436 274.848 179.998 288.582 179.998 288.582C179.998 288.582 179.214 270.13 173.32 258.356C167.426 246.582 162.33 241.878 156.842 238.336C153.313 236.199 149.249 235.111 145.124 235.2Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M145.124 209.72C145.124 209.72 142.324 230.132 141.596 236.81C140.868 243.488 136.892 240.338 139.244 248.584C141.596 256.83 154.546 290.584 157.304 287.784C160.062 284.984 168.686 251.678 170.646 249.312C172.606 246.946 176.148 242.312 176.148 242.312L145.124 209.72Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M144.872 211.596C144.34 215.6 143.066 225.148 142.212 231.826L172.2 242.424L169.792 235.676L147.77 212.534L144.872 211.596Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2742 265.076C99.2742 265.076 84.3642 273.322 83.9722 277.676C83.5802 282.03 56.0982 378.532 58.8002 385.98C61.5022 393.428 74.5082 394.618 74.5082 394.618C74.5082 394.618 86.6742 374.598 93.3522 371.07C96.2781 369.447 99.3088 368.02 102.424 366.8L116.55 299.6",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2742 265.076C99.2742 265.076 84.3642 273.322 83.9722 277.676C83.5802 282.03 56.0982 378.532 58.8002 385.98C61.5022 393.428 74.5082 394.618 74.5082 394.618C74.5082 394.618 86.6742 374.598 93.3522 371.07C96.2781 369.447 99.3088 368.02 102.424 366.8L116.55 299.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M196.238 389.522C198.132 391.83 200.387 393.816 202.916 395.402C206.836 397.768 211.946 398.944 208.418 400.512C204.89 402.08 199.388 399.728 196.238 397.712C193.088 395.696 196.238 389.522 196.238 389.522Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M109.872 373.8C109.872 373.8 109.648 373.506 109.228 373.016C106.873 370.176 104.028 367.782 100.828 365.946C96.1102 363.594 81.9842 363.146 69.8042 377.342C57.6242 391.538 63.9242 398.538 73.7382 400.89C83.5522 403.242 120.456 405.202 129.472 406.784C138.488 408.366 155.386 409.584 161.672 406.784C165.897 404.97 170.221 403.395 174.622 402.066C174.622 402.066 176.582 408.352 179.34 408.352C182.098 408.352 181.72 406 181.72 406C181.72 406 183.288 407.582 184.52 407.582C185.539 407.435 186.502 407.03 187.32 406.406C187.932 406.861 188.641 407.168 189.392 407.304C190.142 407.44 190.913 407.401 191.646 407.19C193.998 406.406 193.998 405.216 193.998 405.216C193.998 405.216 196.798 407.582 197.932 405.216C199.066 402.85 197.134 395.01 196.35 389.522C195.566 384.034 191.646 384.02 191.646 384.02L190.442 383.166C189.84 382.74 189.154 382.448 188.43 382.308C187.705 382.168 186.96 382.183 186.242 382.354L184.226 382.844C184.226 382.844 180.306 382.06 178.332 382.844C176.358 383.628 159.894 393.442 157.528 394.618C155.162 395.794 148.89 394.618 141.834 391.818C134.778 389.018 113.4 379.708 109.872 373.8Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M174.65 402.08L173.404 396.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8222 388.346C89.4602 376.6 109.872 373.8 109.872 373.8C109.872 373.8 109.648 373.506 109.228 373.016C106.873 370.176 104.028 367.782 100.828 365.946C96.1102 363.594 81.9842 363.146 69.8042 377.342C57.6242 391.538 63.9242 398.538 73.7382 400.89C74.8442 401.156 76.3282 401.422 78.0642 401.674C77.0002 398.188 77.0002 393.568 80.8222 388.346Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M181.72 406C181.72 406 180.936 389.914 178.178 386.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M187.208 406.406C187.208 406.406 188.398 392.266 185.64 385.588",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M193.886 405.216C194.075 399.419 193.549 393.622 192.318 387.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M223.37 319.564C223.37 319.564 219.17 314.048 216.482 316.764C213.794 319.48 210.14 342.944 210.14 350.112C210.14 357.28 209.034 357 217.574 358.652C226.114 360.304 229.152 360.864 232.47 359.212C235.788 357.56 231.07 347.074 228.606 338.534C226.142 329.994 223.37 319.564 223.37 319.564Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29 200.41C235.442 200.164 236.637 200.217 237.762 200.564Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29 200.41C235.442 200.164 236.637 200.217 237.762 200.564",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M217.406 224.294C218.425 223.373 219.361 222.366 220.206 221.284C223.328 217.378 225.904 206.262 231.154 201.978",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M217.406 224.294C218.425 223.373 219.361 222.366 220.206 221.284C223.328 217.378 225.904 206.262 231.154 201.978",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M214.018 222.418C214.018 222.418 218.218 220.248 219.394 212.618Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M214.018 222.418C214.018 222.418 218.218 220.248 219.394 212.618",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M230.258 260.848L227.22 279.58C227.22 279.58 252.588 332.514 252.868 342.44C253.148 352.366 250.068 358.148 239.078 359.24C228.088 360.332 225.302 357.84 222.544 346.836C219.786 335.832 217.854 280.672 217.854 280.672C217.854 280.672 212.618 273.504 211.232 271.026C210.148 268.779 209.497 266.347 209.314 263.858C209.314 263.032 207.382 239.876 207.382 239.876L227.22 239.596L230.258 260.848Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M228.718 258.496L218.554 259.994C218.248 260.059 217.932 260.063 217.624 260.004C217.316 259.945 217.023 259.825 216.763 259.652C216.502 259.479 216.278 259.255 216.105 258.994C215.932 258.733 215.813 258.44 215.754 258.132L215.25 255.584C215.185 255.278 215.182 254.961 215.24 254.654C215.299 254.346 215.419 254.053 215.592 253.792C215.766 253.532 215.989 253.308 216.25 253.135C216.511 252.962 216.804 252.842 217.112 252.784L227.276 251.3C227.582 251.233 227.898 251.228 228.205 251.285C228.513 251.342 228.806 251.46 229.067 251.632C229.328 251.804 229.552 252.027 229.725 252.288C229.899 252.548 230.018 252.841 230.076 253.148L230.58 255.696C230.643 256.002 230.645 256.318 230.586 256.625C230.526 256.932 230.406 257.224 230.233 257.484C230.06 257.745 229.837 257.968 229.577 258.142C229.317 258.316 229.025 258.436 228.718 258.496Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M230.02 263.844L222.642 264.936C222.417 264.98 222.186 264.979 221.962 264.932C221.738 264.885 221.526 264.794 221.337 264.663C221.149 264.533 220.989 264.365 220.867 264.172C220.745 263.978 220.663 263.762 220.626 263.536L220.262 261.688C220.22 261.464 220.223 261.235 220.271 261.012C220.318 260.79 220.41 260.579 220.541 260.392C220.671 260.206 220.838 260.047 221.03 259.926C221.223 259.805 221.438 259.723 221.662 259.686L229.04 258.594C229.493 258.512 229.96 258.614 230.338 258.877C230.716 259.139 230.974 259.541 231.056 259.994L231.42 261.842C231.462 262.066 231.459 262.295 231.412 262.518C231.364 262.74 231.272 262.951 231.141 263.138C231.011 263.324 230.845 263.483 230.652 263.604C230.459 263.725 230.245 263.807 230.02 263.844Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M228.886 243.194L218.134 244.776C217.486 244.904 216.814 244.769 216.266 244.401C215.717 244.034 215.337 243.464 215.208 242.816L214.69 240.114C214.627 239.794 214.628 239.465 214.692 239.145C214.757 238.826 214.884 238.522 215.066 238.251C215.248 237.981 215.482 237.749 215.754 237.569C216.025 237.389 216.33 237.264 216.65 237.202L227.402 235.62C228.048 235.497 228.717 235.633 229.262 236C229.807 236.367 230.186 236.935 230.314 237.58L230.846 240.282C230.909 240.602 230.909 240.931 230.844 241.251C230.78 241.571 230.653 241.874 230.471 242.145C230.289 242.415 230.055 242.647 229.783 242.827C229.511 243.007 229.206 243.132 228.886 243.194Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M229.978 251.188L219.226 252.77C218.906 252.833 218.577 252.832 218.257 252.768C217.938 252.704 217.634 252.577 217.363 252.395C217.093 252.212 216.861 251.979 216.681 251.707C216.501 251.435 216.376 251.13 216.314 250.81L215.782 248.108C215.719 247.788 215.72 247.459 215.784 247.139C215.849 246.82 215.976 246.516 216.158 246.245C216.34 245.975 216.573 245.743 216.845 245.563C217.117 245.383 217.422 245.258 217.742 245.196L228.494 243.614C229.142 243.49 229.812 243.627 230.359 243.993C230.907 244.36 231.288 244.928 231.42 245.574L231.938 248.276C232.003 248.596 232.004 248.926 231.94 249.246C231.877 249.567 231.75 249.871 231.568 250.142C231.385 250.413 231.151 250.645 230.878 250.825C230.605 251.004 230.299 251.128 229.978 251.188Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M141.778 198.912C141.778 198.912 138.81 169.12 135.226 158.984C131.642 148.848 144.76 137.536 175.742 138.138C206.724 138.74 218.05 152.432 218.638 158.984C219.226 165.536 211.484 170.31 211.484 170.31L208.516 178.71L181.104 172.158C181.104 172.158 181.104 179.298 178.724 182.28C176.344 185.262 162.638 190.022 162.638 190.022C162.638 190.022 159.656 200.746 154.896 206.108C150.136 211.47 142.968 210.882 142.38 207.312C141.986 204.529 141.785 201.723 141.778 198.912Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M148.932 204.274C148.932 204.274 150.724 192.36 141.19 192.36C131.656 192.36 134.036 204.274 136.99 210.224C139.944 216.174 143.542 217.378 143.542 217.378C143.542 217.378 162.008 241.808 168.56 245.378C175.112 248.948 178.696 251.342 183.456 248.948C188.216 246.554 202.524 228.704 204.904 219.17C206.298 213.914 207.101 208.518 207.298 203.084C207.298 203.084 212.66 191.758 212.66 186.396C212.66 181.034 211.456 170.31 211.456 170.31C211.456 170.31 185.248 160.776 177.506 162.568C169.764 164.36 166.18 163.758 169.75 166.768C173.32 169.778 175.112 178.682 172.732 179.872C170.352 181.062 156.058 181.062 156.058 186.424C156.058 191.786 157.836 194.824 155.456 197.75C153.445 200.083 151.265 202.263 148.932 204.274Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M187.88 223.384C187.88 223.384 196.126 224.56 197.68 222.6C199.234 220.64 198.87 205.716 198.87 205.716L204.75 197.47C204.75 197.47 208.292 195.118 209.86 197.47",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M185.136 235.942L190.638 233.982",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M183.12 202.888C182.56 204.988 181.104 206.444 179.858 206.108C178.612 205.772 178.08 203.812 178.64 201.698C179.2 199.584 180.656 198.142 181.888 198.464C183.12 198.786 183.68 200.774 183.12 202.888Z",
    fill: "#263238"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M205.436 206.318C204.876 208.432 203.42 209.874 202.188 209.538C200.956 209.202 200.396 207.242 200.956 205.128C201.516 203.014 202.972 201.572 204.204 201.894C205.436 202.216 205.996 204.204 205.436 206.318Z",
    fill: "#263238"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M177.674 192.374C177.674 192.374 183.568 188.44 192.206 193.55",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M189.868 229.6L196.21 270.816L218.008 269.234L219.198 227.612C219.198 227.612 210.084 224.476 189.868 229.6Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M486.388 567.882L503.118 638.722C503.244 639.221 503.254 639.743 503.147 640.247C503.041 640.751 502.82 641.223 502.503 641.629C502.185 642.034 501.779 642.361 501.315 642.586C500.852 642.81 500.343 642.925 499.828 642.922H478.716V648.2H505.4C506.359 648.201 507.305 647.982 508.166 647.56C509.028 647.138 509.781 646.524 510.367 645.766C510.954 645.007 511.359 644.124 511.551 643.185C511.744 642.245 511.718 641.274 511.476 640.346L490.476 560.196L486.388 567.882Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M503.338 491.063L494.077 489.457L471.386 620.263L480.647 621.87L503.338 491.063Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.994636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M447.846 644.518H362.46V648.214H447.846V644.518Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M564.424 406.49H397.194V411.278H564.424V406.49Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M564.41 406.49H505.708V411.278H564.41V406.49Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M507.696 406.49H399.112L388.556 334.278C388.409 333.507 388.437 332.712 388.638 331.953C388.839 331.194 389.207 330.49 389.717 329.892C390.226 329.294 390.862 328.818 391.58 328.499C392.297 328.18 393.077 328.026 393.862 328.048H490C491.725 328.102 493.378 328.753 494.677 329.889C495.977 331.024 496.842 332.576 497.126 334.278L507.696 406.49Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M505.61 406.49H397.026L386.47 334.278C386.323 333.506 386.351 332.71 386.553 331.95C386.755 331.189 387.124 330.484 387.635 329.886C388.146 329.288 388.784 328.813 389.503 328.494C390.223 328.176 391.004 328.024 391.79 328.048H487.914C489.641 328.102 491.296 328.752 492.597 329.887C493.899 331.023 494.767 332.575 495.054 334.278L505.61 406.49Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M167.93 411.278H338.842V406.392H167.93V411.278Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M167.944 411.278H227.934V406.392H167.944V411.278Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M225.918 406.392H336.882L347.676 332.584C347.825 331.795 347.795 330.983 347.589 330.207C347.382 329.431 347.005 328.711 346.484 328.1C345.963 327.489 345.311 327.002 344.578 326.676C343.844 326.35 343.047 326.192 342.244 326.214H244.006C242.241 326.268 240.549 326.932 239.219 328.094C237.889 329.255 237.003 330.842 236.712 332.584L225.918 406.392Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M228.046 406.392H339.01L349.804 332.584C349.955 331.796 349.927 330.985 349.724 330.209C349.52 329.434 349.145 328.713 348.627 328.101C348.109 327.489 347.461 327.001 346.729 326.672C345.998 326.343 345.202 326.182 344.4 326.2H246.134C244.369 326.254 242.677 326.918 241.347 328.08C240.017 329.241 239.131 330.828 238.84 332.57L228.046 406.392Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M286.79 364C287.111 362.095 288.078 360.359 289.529 359.084C290.98 357.809 292.826 357.073 294.756 357C295.639 356.971 296.517 357.141 297.325 357.498C298.132 357.856 298.849 358.391 299.421 359.064C299.993 359.737 300.406 360.53 300.628 361.385C300.851 362.24 300.877 363.134 300.706 364C300.385 365.907 299.416 367.645 297.962 368.92C296.508 370.196 294.659 370.93 292.726 371C291.845 371.025 290.97 370.851 290.166 370.492C289.361 370.133 288.647 369.597 288.077 368.925C287.508 368.253 287.096 367.462 286.873 366.609C286.65 365.757 286.622 364.865 286.79 364Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M35 648.214H688.408",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M674.422 411.278H377.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M359.772 411.278H31.6958",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M265.874 428.4C265.874 428.4 263.368 404.32 250.782 396.774C238.196 389.228 244.678 409.71 244.678 410.774C244.678 411.838 225.988 391.006 210.168 402.5C194.348 413.994 209.09 438.088 209.09 438.088C209.09 438.088 190.05 431.62 190.4 438.452C190.75 445.284 208.376 451.052 208.376 451.052C208.376 451.052 176.386 454.286 187.894 468.664C199.402 483.042 230.664 472.612 230.664 472.612C230.664 472.612 222.026 481.964 228.144 483.042C234.262 484.12 257.544 465.794 259.77 461.118C261.996 456.442 274.148 442.4 265.874 428.4Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M337.064 472.514C337.064 472.514 348.754 471.898 354.914 462.056C361.074 452.214 358.596 445.438 349.314 441.756C340.032 438.074 327.166 439.908 327.166 439.908C327.166 439.908 307.524 415.296 279.832 421.4C252.14 427.504 248.444 449.092 250.292 460.166L257.684 504.476C257.684 504.476 280.448 508.172 286.608 502.012C292.768 495.852 304.444 473.704 316.75 470.638C329.056 467.572 337.064 472.514 337.064 472.514Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M341.166 493.738C340.41 499.268 336.448 507.038 332.64 506.52C328.832 506.002 326.34 501.116 327.04 495.586C327.74 490.056 331.786 489.286 335.594 489.804C339.402 490.322 341.908 488.222 341.166 493.738Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M275.52 487.284C275.52 487.284 280.448 489.132 287.84 483.602C295.232 478.072 295.218 464.52 311.22 461.44C327.222 458.36 337.68 465.752 338.296 470.064C338.912 474.376 336.448 482.986 336.448 491.596C336.448 500.206 338.296 504.518 340.144 506.366C341.992 508.214 344.442 506.982 340.76 510.678C337.335 513.7 333.621 516.378 329.672 518.672C329.672 518.672 319.214 538.37 314.916 542.052C310.618 545.734 300.146 543.9 296.45 542.052C292.754 540.204 284.76 535.906 284.76 535.906L279.832 553.14L250.292 529.2L257.684 504.588C257.684 504.588 272.454 500.822 275.52 487.284Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M284.76 535.906L276.836 526.904L281.106 545.706L284.76 535.906Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M331.632 495.474C331.422 497.84 330.232 499.674 328.916 499.548C327.6 499.422 326.774 497.42 326.984 495.04C327.194 492.66 328.384 490.84 329.7 490.966C331.016 491.092 331.8 493.094 331.632 495.474Z",
    fill: "#263238"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M319.872 489.804L277.732 486.99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M333.802 495.614H337.218",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M324.464 480.522C325.943 479.723 327.632 479.398 329.303 479.591C330.973 479.784 332.543 480.485 333.802 481.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M324.464 525.812C324.464 525.812 319.788 525.812 316.554 520.422",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M284.2 569.114L289.8 648.564H168.378C168.378 648.564 187.348 588.084 193.284 575.442C199.22 562.8 206.724 557.242 206.724 557.242C206.724 557.242 222.124 543.41 243.124 546.168C264.124 548.926 284.2 569.114 284.2 569.114Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M279.216 492.212C279.216 492.212 276.752 479.906 268.142 481.754C259.532 483.602 263.83 502.67 269.374 508.214C274.918 513.758 278.6 507.598 278.6 507.598",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M279.216 492.212C279.216 492.212 276.752 479.906 268.142 481.754C259.532 483.602 263.83 502.67 269.374 508.214C274.918 513.758 278.6 507.598 278.6 507.598",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M286.566 574.252C286.566 574.252 291.312 565.95 287.364 559.23C283.416 552.51 271.6 539.07 255.346 526.4C239.092 513.73 217.784 497.546 214.634 506.24C211.484 514.934 209.034 531.93 209.034 531.93C209.034 531.93 195.202 534.296 193.634 538.65C192.066 543.004 190.47 564.746 192.85 567.504C195.23 570.262 196.798 567.112 201.936 567.112C207.074 567.112 238.336 556.836 250.166 557.62C261.996 558.404 263.998 561.974 273.084 566.72C282.17 571.466 286.566 574.252 286.566 574.252Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M278.446 559.916C280.689 561.557 282.749 563.435 284.592 565.516",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M218.526 539.966C227.57 538.09 238.546 537.096 246.246 540.652C256.019 545.237 265.386 550.641 274.246 556.808",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M202.37 544.6C206.876 542.922 211.487 541.543 216.174 540.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M214.2 532C214.2 532 224.084 528.052 237.524 532.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M229.25 572.278C232.414 565.558 242.69 550.536 258.51 558.446C274.33 566.356 278.264 585.326 285.39 608.65C292.516 631.974 299.222 648.564 299.222 648.564H240.324L225.694 589.666",
    fill: "#1B5FAD"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M229.25 572.278C232.414 565.558 242.69 550.536 258.51 558.446C274.33 566.356 278.264 585.326 285.39 608.65C292.516 631.974 299.222 648.564 299.222 648.564H240.324L225.694 589.666",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M356.076 648.452L362.614 642.852C362.614 642.852 370.37 644.714 382.998 640.822C395.626 636.93 399.798 633.178 399.798 633.178C403.745 635.038 407.557 637.172 411.208 639.562C417.004 643.412 421.204 644.896 426.804 643.37C432.404 641.844 425.278 640.304 419.076 635.936C412.874 631.568 405.398 625.534 405.398 625.534C405.398 625.534 417.116 631.134 421.204 632.674C425.292 634.214 429.352 636.748 432.922 635.222C436.492 633.696 434.952 632.156 425.782 627.578C417.382 623.378 407.946 615.342 403.382 615.342C398.818 615.342 377.902 624.008 377.902 624.008L337.008 648.466L356.076 648.452Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M370.37 638.582C373.461 639.573 376.744 639.813 379.946 639.282C384.524 638.26 390.642 637.238 390.642 637.238C390.642 637.238 402.864 637.756 406.952 637.238C411.04 636.72 410.004 634.186 403.382 631.638C396.76 629.09 371.798 627.564 371.28 629.09C370.797 632.234 370.493 635.403 370.37 638.582Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M407.582 624.974C407.582 624.974 417.27 628.6 419.09 629.804C420.91 631.008 424.536 631.932 423.01 634.004C421.484 636.076 416.668 634.312 413.336 633.696C410.719 633.086 408.183 632.174 405.776 630.98L407.582 624.974Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M382.48 619.528C382.48 619.528 399.714 620.438 403.648 621.642C407.582 622.846 410.648 631.022 411.222 633.444C411.796 635.866 413.938 638.89 412.118 639.184C410.298 639.478 403.648 631.932 400.918 630.42C398.188 628.908 387.296 623.756 383.362 622.244C379.428 620.732 380.352 619.22 382.48 619.528Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M331.898 645.47C331.898 645.47 371.42 617.47 375.648 617.47C379.876 617.47 398.832 625.87 403.046 628.012C407.26 630.154 412.538 641.718 412.538 641.718C412.538 641.718 411.474 644.35 407.792 642.25C404.11 640.15 399.882 633.29 399.882 633.29L378.882 632.478C378.882 632.478 373.576 637.476 370.412 638.526C366.933 639.391 363.396 640 359.828 640.346L353.024 646.464L331.898 645.47Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M350.7 631.932L359.786 648.564H320.46L350.7 631.932Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M334.46 489.006C334.46 489.006 322.63 484.666 321.048 487.438C319.466 490.21 317.898 500.444 324.212 504.784C330.526 509.124 333.802 495.614 333.802 495.614",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M369.6 217C398.208 217 421.4 193.808 421.4 165.2C421.4 136.592 398.208 113.4 369.6 113.4C340.991 113.4 317.8 136.592 317.8 165.2C317.8 193.808 340.991 217 369.6 217Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M369.6 211.358C395.092 211.358 415.758 190.692 415.758 165.2C415.758 139.708 395.092 119.042 369.6 119.042C344.108 119.042 323.442 139.708 323.442 165.2C323.442 190.692 344.108 211.358 369.6 211.358Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M357.238 178.164L369.6 165.2L401.786 188.65",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgHomeOffice as ReactComponent };
export default "/65fed87c36104913a49f4ff65dec33da.svg";